var g_devtricker_offcanvas_comments_instance;

function handleKeyboardShortcut(event) {
    if (event.ctrlKey && event.shiftKey && event.code === 'KeyC') {
        event.preventDefault();
        
        var offcanvasCommentsElement = document.getElementById('offcanvasComments');

        if (!g_devtricker_offcanvas_comments_instance) {
            g_devtricker_offcanvas_comments_instance = new bootstrap.Offcanvas(offcanvasCommentsElement);
        }

        if (offcanvasCommentsElement.classList.contains('show')) {
            g_devtricker_offcanvas_comments_instance.hide();
        } else {
            g_devtricker_offcanvas_comments_instance.show();
        }
    }
}

document.addEventListener('keydown', handleKeyboardShortcut);